<nav class="bg-purple-21 navbar navbar-primary navbar-primary-2 navbar-primary-home-2 sticky-top">
    <div class="container-fluid no-padding">
        <div>
            <button class="lateral-menubar-toggler d-lg-none mgn-rigth-3 navbar-toggler-2 btn-tooltip-help"
                type="button" aria-label="Control barra de menú lateral" (click)="onClickToogleMenu($event)"
                data-toggle="popover" data-placement="bottom" data-trigger="manual" data-html="true"
                data-content='<div class="text-left"><strong class="text-uppercase d-block font-size-110-p">Nuevo</strong><p>Haz "clic" para colapsar o expandir la barra de menú lateral. ¡Prúebalo ahora!</p><a class="white-link font-weight-bold btn-close-tooltip" href="#">Ok, gracias &gt;</a></div>'
                tabindex="0">
                <span class="navbar-toggler-icon"></span>
            </button>

            <a class="navbar-brand" [routerLink]="['/']" title="Ir a Home de Profejobs"><img
                    src="images/logo-pj-blanco2x.png" alt="Logotipo de Profejobs" class="logo-main-navbar"
                    loading="lazy" /></a>

        </div>
        <div class="align-items-center d-flex no-padding-right wrap-navItem">
            <ul class="align-items-center navbar-nav navbar-nav-custom navbar-nav-no-hover navbar-nav-user-info">

                <li class="nav-item dropdown dropdown-personal-setting no-change-style">
                    <a class="dropdown-toggle nav-link pj-ico" href="#" id="dropdownMainMenu" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" title="Ajustes de la cuenta"><img loading="lazy"
                            class="school-img" alt="Logotipo del colegio" src="{{userService.getUserPhoto()}}" />
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMainMenu">

                        <a role="button" class="dropdown-item">Perfil: <b>{{userService.getUserProfile()}}</b></a>
                        <a class="dropdown-item" *ngIf="userService.isAdminEmployer()"
                            [routerLink]="['/', path_module_admin.module, path_module_admin.changeemployer]">Seleccionar
                            institución</a>
                        <a class="dropdown-item" *ngIf="userService.isEmployer()" role="button"
                            (click)="onClickEditUser($event)">Editar
                            usuario</a>
                        <a class="dropdown-item"
                            [routerLink]="['/', path_module_employer.module, path_module_employer.changepass]">Cambiar
                            contraseña</a>
                        <a class="dropdown-item" [routerLink]="['/', path_module_public.logout]">Cerrar sesión</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>